import React, { useEffect, useState } from "react";
import {
  // ActionBarPpsItemComp,
  CreatePpsComp,
  DatatablePpsItem,
  ItemPpsComp,
  EditPpsComp,
  DetailPpsComp,
} from "../../components/moleculs";
import axios from "../../library/axios";
import { useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { MySwal } from "../../library/swal";
import {
  IconArrowLeft,
  IconSquareRoundedPlus,
  IconRefresh,
} from "@tabler/icons-react";
import { useLocation } from "react-router-dom";
import { LoadingAtom } from "../../components/atoms";
import { validationAccess } from "../../helpers/validationAccess"
import { getModule, setHrefWithSlugHook, } from "../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../src/config/routes/guards/slug";
import { getApiErrorMessage } from '../../helpers/apiErrorMessage';
import { notifyApiError, notifyApiLoadError } from '../../helpers/notifyApiError';

const PpsItemPage = () => {
  const routeParams = useParams();
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  const [search, setSearch] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [itemPps, setItemPps] = useState([]);
  const [listItemPps, setListItemPps] = useState([]);
  const [ubahItemPps, setubahItemPps] = useState([]);
  const [lgShowDetail, setLgShowDetail] = useState(false);
  const [lgShowAdd, setLgShowAdd] = useState(false);
  const [lgShowUpdate, setLgShowUpdate] = useState(false);
  const [disabledBtnSync, setDisabledBtnSync] = useState(false);
  const [loadingData, setloadingData] = useState(true);
  const [idKegiatanAkreditasi, setidKegiatanAkreditasi] = useState("");
  const [role, setRole] = useState("");

  const handleSyncItemPps = () => {
    MySwal.fire({
      title: "Apa anda yakin ?",
      text: "Laporan PPS 'NOT SYNC' akan di sinkron ke SPEAK Online.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ya, Lanjutkan!",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        setDisabledBtnSync(true);
        const requestBody = {
          idSkorRs: routeParams.id,
        };

        axios({
          url: "/pps-item/syncItemPpsToOnline",
          method: "POST",
          data: requestBody,
          headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
        })
          .then((res) => {
            // console.log(res);
            // return false;
            if (res.status === 200) {
              fetchItemPps();
              MySwal.fire({
                icon: "success",
                title: "Success",
                text: res?.data?.message || 'Permintaan tidak berhasil diproses. Silakan coba lagi.',
              });
              setDisabledBtnSync(false);
            }
          })
          .catch((err) => {
            if (err !== "") {
              console.log(err?.response?.data?.message);
              MySwal.fire({
                icon: "error",
                title: "Oops, Error!",
                text: getApiErrorMessage(err),
              });
              setDisabledBtnSync(false);
            }
          });
      }
    });
  };

  const fetchItemPps = async () => {
    try {
      const options = {
        url: `/pps-item/param-id-skor-rs/${routeParams.id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data.data);
      setTimeout(() => {
        setloadingData(false);
      }, 1000);
      setListItemPps(data?.data);
      setFilterData(data?.data?.ppa_t_item_pps);
      setItemPps(data?.data?.ppa_t_item_pps);
      setubahItemPps(data?.data?.ppa_t_item_pps);
      setidKegiatanAkreditasi(data?.data?.idKegiatanAkreditasi);
    } catch (err) {
      setloadingData(false);
      notifyApiLoadError(err, 'pages/pps-item/index.fetchItemPps');
    }
  };

  const handleHapusPps = (id) => {
    MySwal.fire({
      title: "Apa anda yakin menghapus data ini?",
      text: "Anda tidak akan dapat mengembalikan data ini!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ya, Hapus Data!",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
          },
        };

        axios
          .delete(`/pps-item/delete/${id}`, config)
          .then((res) => {
            // console.log(res)
            // return false
            if (res.status === 200) {
              MySwal.fire({
                icon: "success",
                title: "Success",
                text: "Hapus Item PPS Berhasil!",
              });
              // return false
              setTimeout(() => {
                fetchItemPps();
              }, 3000);
            }
          })
          .catch((err) => {
            if (err !== "") {
              notifyApiError(err, { context: 'pages/pps-item/index.handleHapusPps' });
              // err({ err: err?.response?.data || err });
            }
          });
      }
    });
  };

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      notifyApiLoadError(err, 'pages/pps-item/index.fetchOneUser');
    }
  };

  useEffect(() => {
    validateReccomendation()
  }, []);

  const validateReccomendation = () => {

    const requestBody = {
      idSkor: routeParams.id,
    };

    axios({
      url: "/pps-item/validate-item-pps",
      method: "POST",
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res.status)
        // return false
        if (res.status === 200) {
          fetchItemPps();
          fetchLoginStatus();
          fetchOneUser();
        } else {
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: res?.data?.message || 'Permintaan tidak berhasil diproses. Silakan coba lagi.',
          });
        }
      })
      .catch((err) => {
        if (err !== "") {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: getApiErrorMessage(err),
          });
        }
      });
  };

  const handleChangeSearch = (text) => {
    setSearch(text);
  };

  const handleEditPps = (ubahItemPps) => {
    setubahItemPps(ubahItemPps);
    setLgShowUpdate(true);
  };

  const handleDetailPps = (itemPps) => {
    setItemPps(itemPps);
    setLgShowDetail(true);
  };

  const fetchLoginStatus = async () => {
    // console.log(id)
    // return false
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: "info",
          title: "Oops, Unauthorize!",
          text: "Session anda habis, Silahkan login kembali.",
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook("/login");
        }, 3000);
      } else {
        // console.log(data?.data?.mapping_groups[0].module.pathModule)
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname == mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: "info",
            title: "Oops, No Access!",
            text: "Anda tidak memiliki akses di halaman ini.",
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook("/login");
          }, 3000);
        }
      }
    } catch (err) {
      notifyApiLoadError(err, 'pages/pps-item/index.fetchLoginStatus');
    }
  };

  useEffect(() => {
    const result = itemPps?.filter((item) => {
      let langkahPemenuhan = item.langkahPemenuhan;
      let metodePerbaikan = item.metodePerbaikan;
      let indikatorPencapaian = item.indikatorPencapaian;
      let jangkaWaktuPerbaikan = item.jangkaWaktuPerbaikan;
      let kategoriPeriode = item.kategoriPeriode;
      let kategoriPerbaikan = item.kategoriPerbaikan;

      return langkahPemenuhan
        .concat(metodePerbaikan)
        .concat(indikatorPencapaian)
        .concat(jangkaWaktuPerbaikan)
        .concat(kategoriPeriode)
        .concat(kategoriPerbaikan)
        .toLowerCase()
        .match(search.toString().toLowerCase());
    });
    setFilterData(result);
  }, [search]);

  const handleChangePage = () => {
    setHrefWithSlugHook(`/pps/${idKegiatanAkreditasi}`);
  };
  // console.log(role);

  return (
    <>
      {/*begin::Content*/}
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        {/*begin::Toolbar*/}
        <div className="toolbar" id="kt_toolbar">
          {/*begin::Container*/}
          <div
            id="kt_toolbar_container"
            className="container-fluid d-flex flex-stack"
          >
            {/*begin::Page title*/}
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              {/*begin::Title*/}
              <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
                Perencanaan Perbaikan Strategis (PPS)
                {/*begin::Separator*/}
                <span className="h-20px border-gray-200 border-start ms-3 mx-2" />
                {/*end::Separator*/}
                {/*begin::Description*/}
                <small className="text-muted fs-7 fw-bold my-1 ms-1">
                  #SPEAK_VERSI_RS
                </small>
                {/*end::Description*/}
              </h1>
              {/*end::Title*/}
            </div>
            {/*end::Page title*/}
            {/*begin::Actions*/}
            {/* <ActionBarPpsItemComp showFormAdd={() => setLgShowAdd(true)} /> */}
            {/*end::Actions*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Toolbar*/}
        {/*begin::Post*/}
        <div className="post d-flex flex-column-fluid" id="kt_post">
          {/*begin::Container*/}
          <div id="kt_content_container" className="container-xxl">
            {/*begin::Row*/}
            <div className="row gy-5 g-xl-8">
              {/*begin::Col*/}
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between mb-5">
                      <div>
                        <h5 className="card-title">Daftar Item PPS</h5>
                      </div>
                      <div>
                        {loadingData === true ? (
                          ""
                        ) : (
                          <>
                            {role === "Kelompok Kerja" ||
                              role === "Surveior Internal" ? (
                              <a
                                onClick={() => setLgShowAdd(true)}
                                className="btn btn-sm btn-primary"
                              >
                                <IconSquareRoundedPlus stroke={2} /> Tambah
                                Laporan
                              </a>
                            ) : (
                              ""
                            )}
                            &nbsp;
                            <button
                              onClick={() => handleSyncItemPps()}
                              className="btn btn-sm btn-danger"
                              disabled={disabledBtnSync}
                            >
                              <IconRefresh stroke={2} /> Sync Item PPS
                            </button>
                            &nbsp;
                            <button
                              onClick={() => handleChangePage()}
                              className="btn btn-sm btn-info"
                            >
                              <IconArrowLeft stroke={2} /> Kembali
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                    {loadingData === true ? (
                      <LoadingAtom />
                    ) : (
                      <>
                        <ItemPpsComp ppsitem={listItemPps} />
                        <DatatablePpsItem
                          idRekomendasi={routeParams.id}
                          ppsitem={filterData}
                          search={search}
                          role={role}
                          handleChangeSearch={handleChangeSearch}
                          handleDetailPps={handleDetailPps}
                          handleEditPps={handleEditPps}
                          handleHapusPps={handleHapusPps}
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
              {/*end::Col*/}
            </div>
            {/*end::Row*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Post*/}
      </div>
      {/*end::Content*/}

      <Modal
        show={lgShowAdd}
        onHide={() => setLgShowAdd(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b>Form Laporan Perencanaan Perbaikan Strategis</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreatePpsComp
            close={() => setLgShowAdd(false)}
            fetch={() => fetchItemPps()}
            recommendation={listItemPps}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={lgShowUpdate}
        onHide={() => setLgShowUpdate(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b>Form Ubah Laporan Perencanaan Perbaikan Strategis</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditPpsComp
            ubahItemPps={ubahItemPps}
            close={() => setLgShowUpdate(false)}
            fetch={() => fetchItemPps()}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={lgShowDetail}
        onHide={() => setLgShowDetail(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b>Detail Laporan Perencanaan Perbaikan Strategis</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DetailPpsComp
            itemPps={itemPps}
            close={() => setLgShowDetail(false)}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PpsItemPage;
